import { DETAIL_MOVIE, FETCH_MOVIE, MOVIE_GENRE } from "./actiontype";

const baseUrl= "https://server-project1-phase3.herokuapp.com"

export const fetchMovieSuccess=(payload)=>{
    return {
        type: FETCH_MOVIE,
        payload
    }
}

export const fetchMovie=()=>{
    return(dispatch,getState)=>{
        return fetch(`${baseUrl}/public/movies`)
        .then((response)=>{
            return response.json()
        })
        .then((data)=>{
            dispatch(fetchMovieSuccess(data))
        })
        .catch((error)=>{
            console.log(error);
        })
    }
}

export const fetchDetailMovieSuccess=(payload)=>{
    return{
        type: DETAIL_MOVIE,
        payload
    }
} 

export const fetchMovieDetail= (id)=>{
return(dispatch,getState)=>{
    return fetch(`${baseUrl}/public/movies/${id}`,{
        method:'get',
        headers:{
            'Content-Type': 'application/json'
        }
    })
    .then((response)=>{
        return response.json()
    })
    .then((data)=>{
        dispatch(fetchDetailMovieSuccess(data))
    })
    .catch((error)=>{
        console.log(error);
    })
}
}

export const fetchGenreSuccess= (payload)=>{
    return{
        type: MOVIE_GENRE,
        payload
    }
}

export const fetchGenre= ()=>{
    return(dispatch,getState)=>{
        return fetch(`${baseUrl}/public/genres`,{
            method:'get',
            headers:{
                'Content-Type': 'application/json'
            }
        })
        .then((response)=>{
            return response.json()
        })
        .then((data)=>{
            console.log(data);
            dispatch(fetchGenreSuccess(data))
        })
        .catch((error)=>{
            console.log(error);
        })
    }
    }